"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
import { AccountSessionMixins } from "@/service/account-session";
import API from "@ym-framework/api-utils";
import QuestionSlot from "@/components/QuestionSlot.vue";
let EditUADialog = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.ids = [];
    this.names = [];
    this.selectedBrowserCore = "auto";
    this.selectedUserAgent = "auto";
    this.browserCoreList = [];
    this.userAgentList = [];
    this.browserVersion = "chrome";
    this.systemUnify = false;
    this.systemUACode = "";
    this.systemUAData = "";
    this.windowsUAList = [];
    this.macUAList = [];
    this.androidUAList = [];
    this.systemUAList = [];
    this.windowsUAData = "";
    this.windowsUACode = "";
    this.macUAData = "";
    this.macUACode = "";
    this.androidUAData = "";
    this.androidUACode = "";
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  open(ids, names, browserVersion) {
    return __async(this, null, function* () {
      this.ids = ids;
      this.names = names;
      this.browserVersion = browserVersion;
      this._edit_ua_dialog.show();
      yield this.checkBrowserCore();
    });
  }
  changeUnify() {
    return __async(this, null, function* () {
    });
  }
  getUAList() {
    return __async(this, null, function* () {
      try {
        let data = {
          browser: this.browserVersion
        };
        if (this.selectedBrowserCore === "auto") {
          let result = yield API.get(
            `api://base.auth/api/v1/useragents/os`,
            {
              params: data
            }
          );
          if (result.data.os.hasOwnProperty("windows")) {
            this.systemUAList = result.data.useragent[result.data.os.windows[0]];
            this.systemUACode = result.data.os.windows[0];
            this.systemUAData = this.systemUAList[0];
            this.windowsUAList = result.data.useragent[result.data.os.windows[0]];
            this.windowsUACode = result.data.os.windows[0];
            this.windowsUAData = this.windowsUAList[0];
          } else {
            this.windowsUAList = [];
            this.windowsUAData = "";
            this.windowsUACode = "";
            this.systemUAList = [];
            this.systemUACode = "";
            this.systemUAData = "";
          }
          if (result.data.os.hasOwnProperty("mac")) {
            this.macUAList = result.data.useragent[result.data.os.mac[0]];
            this.macUACode = result.data.os.mac[0];
            this.macUAData = this.macUAList[0];
          } else {
            this.macUAList = [];
            this.macUAData = "";
            this.macUACode = "";
          }
          if (result.data.os.hasOwnProperty("android")) {
            this.androidUAList = result.data.useragent[result.data.os.android[0]];
            this.androidUACode = result.data.os.android[0];
            this.androidUAData = this.androidUAList[0];
          } else {
            this.androidUAList = [];
            this.androidUACode = "";
            this.androidUAData = "";
          }
        } else {
          data.browserVersion = this.selectedBrowserCore;
          let result = yield API.get(`api://base.auth/api/v1/useragents`, {
            params: data
          });
          if (result.data.os.hasOwnProperty("windows")) {
            this.systemUAList = result.data.useragent[result.data.os.windows[0]];
            this.systemUACode = result.data.os.windows[0];
            this.systemUAData = this.systemUAList[0];
            this.windowsUAList = result.data.useragent[result.data.os.windows[0]];
            this.windowsUACode = result.data.os.windows[0];
            this.windowsUAData = this.windowsUAList[0];
          } else {
            this.windowsUAList = [];
            this.windowsUACode = "";
            this.windowsUAData = "";
            this.systemUAList = [];
            this.systemUACode = "";
            this.systemUAData = "";
          }
          if (result.data.os.hasOwnProperty("mac")) {
            this.macUAList = result.data.useragent[result.data.os.mac[0]];
            this.macUACode = result.data.os.mac[0];
            this.macUAData = this.macUAList[0];
          } else {
            this.macUAList = [];
            this.macUACode = "";
            this.macUAData = "";
          }
          if (result.data.os.hasOwnProperty("android")) {
            this.androidUAList = result.data.useragent[result.data.os.android[0]];
            this.androidUACode = result.data.os.android[0];
            this.androidUAData = this.androidUAList[0];
          } else {
            this.androidUAList = [];
            this.androidUACode = "";
            this.androidUAData = "";
          }
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  changeBrowserCore() {
    return __async(this, null, function* () {
      yield this.getUAList();
    });
  }
  // 检测chrome核心列表是否版本一致
  checkBrowserCore() {
    return __async(this, null, function* () {
      try {
        yield this.getBrowserCoreList();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //
  changeUAMode() {
    return __async(this, null, function* () {
      if (this.selectedUserAgent === "custom") {
        this.systemUnify = false;
        yield this.getUAList();
      }
    });
  }
  getBrowserCoreList() {
    return __async(this, null, function* () {
      try {
        let browser_response = yield API.get(
          `api://base.auth/api/v1/browser-versions`
        );
        this.browserCoreList = browser_response.data.browserVersion[this.browserVersion];
        this.browserCoreList.sort((a, b) => {
          return b.version - a.version;
        });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  getUserAgentList(browser) {
    return __async(this, null, function* () {
      try {
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  editUA() {
    return __async(this, null, function* () {
      try {
        let data = __spreadValues(__spreadProps(__spreadValues({
          ids: this.ids,
          browserKernelMode: this.selectedBrowserCore === "auto" ? "SMART" : "MANUAL"
        }, (() => {
          if (this.selectedBrowserCore !== "auto") {
            return {
              browser: {
                code: this.browserVersion,
                versionCode: this.selectedBrowserCore
              }
            };
          }
        })()), {
          userAgentMode: this.selectedUserAgent === "auto" ? "SMART" : "MANUAL"
        }), (() => {
          if (this.selectedUserAgent !== "auto") {
            return {
              osUserAgent: __spreadValues({
                model: this.systemUnify ? "shop.unify.os.ua" : "shop.os.ua"
              }, (() => {
                if (this.systemUnify) {
                  return {
                    unify: {
                      osCode: this.systemUACode,
                      userAgent: this.systemUAData
                    }
                  };
                } else {
                  return __spreadValues(__spreadValues(__spreadValues({}, (() => {
                    if (this.windowsUAData !== "") {
                      return {
                        windows: {
                          osCode: this.windowsUACode,
                          userAgent: this.windowsUAData
                        }
                      };
                    }
                  })()), (() => {
                    if (this.macUAData !== "") {
                      return {
                        mac: {
                          osCode: this.macUACode,
                          userAgent: this.macUAData
                        }
                      };
                    }
                  })()), (() => {
                    if (this.androidUAData !== "") {
                      return {
                        android: {
                          osCode: this.androidUACode,
                          userAgent: this.androidUAData
                        }
                      };
                    }
                  })());
                }
              })())
            };
          }
        })());
        yield API.put(`api://base.auth.pro/v1/shops/browser-ua-batch`, data);
        this.$message.success(
          this.$t("edit_ua_dialog.success_message")
        );
        this.closeDialog();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  closeDialog() {
    return __async(this, null, function* () {
      this.selectedBrowserCore = "auto";
      this.selectedUserAgent = "auto";
      this.systemUnify = false;
      this.systemUAData = "";
      this.systemUACode = "";
      this.windowsUAData = "";
      this.windowsUACode = "";
      this.macUAData = "";
      this.macUACode = "";
      this.androidUAData = "";
      this.androidUACode = "";
      this.ids = [];
      this.names = [];
      this._edit_ua_dialog.hide();
    });
  }
};
__decorateClass([
  Ref("edit-ua-dialog")
], EditUADialog.prototype, "_edit_ua_dialog", 2);
EditUADialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      QuestionSlot
    }
  })
], EditUADialog);
export {
  EditUADialog as default
};
